export const PIXEL_IN_CHAR = 8;
export const FIRST_COL_WIDTH = ((20 / document.body.clientWidth) * 100);
export const LAST_COL_WIDTH = ((20 / document.body.clientWidth) * 100);
export const PAGES_IN_PAGINATION = 2;
export const MAX_ACTION_ICONS = 40;
export const DEFAULT_INPUT_LENGTH = 250;
export const DEFAULT_INPUT_VALIDATION = /^[\p{L}\p{N}\s\-._]*$/u;
export const DEFAULT_INPUT_VALIDATION_HINT = "Only letters, numbers, spaces, hyphens (-), dots (.), and underscores (_), along with Unicode letters, are allowed.";

export const ID_INPUT_VALIDATION = /^[\p{L}\p{N}\s\-._]*$/u;
export const ID_INPUT_VALIDATION_HINT = "Only letters, numbers, spaces, hyphens (-), dots (.), and underscores (_), along with Unicode letters, are allowed.";
export const DEVEUI_INPUT_VALIDATION = "^([a-fA-F0-9\\s\\-\\.\\_:])*$";
export const DEVEUI_INPUT_VALIDATION_HINT = "Only hexadecimal (0-9, A-F), spaces, hyphens (-), dots (.), underscores (_), and colons (:) are allowed.";
export const DEVADDR_INPUT_VALIDATION = "^[A-Fa-f0-9]{0,8}$";
export const DEVADDR_INPUT_VALIDATION_HINT = "Only hexadecimal (0-9, A-F) characters are allowed, up to 8 characters.";
export const APP_ACC_GROUP_ID_INPUT_VALIDATION = /^[\p{L}\p{N}\s\-._@]{1,60}$/u;
export const APP_ACC_GROUP_ID_INPUT_VALIDATION_HINT = "Up to 60 characters. Only letters (including Unicode letters), numbers, spaces, hyphens (-), dots (.), underscores (_), and at symbols (@) are allowed.";
export const DEFAULT_RECORD_LIMIT = 50;

const setDebugValue  = ( newHtml, id  =  'all-extra-debug-value' ) => {
    
    try {
        if(id === 'all-extra-debug-value') {
            var html = document.getElementById(id).innerHTML;
            document.getElementById(id).innerHTML = `${html}<br/>${newHtml}`;
        }else {
            document.getElementById(id).innerHTML = `${newHtml}`;
        }
    }catch(e) {
        //console.log(e);
    }
    

}

export { setDebugValue }